export function formatPhone(value: string) {
  const digits = value.replace(/\D/g, "").slice(0, 11);
  if (digits.length <= 3) return digits;
  if (digits.length <= 7) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
}

export interface PostcodeResult {
  zonecode: string;
  roadAddress: string;
  jibunAddress: string;
}

declare global {
  interface Window {
    daum?: {
      Postcode: new (options: {
        oncomplete: (data: PostcodeResult) => void;
      }) => { open: (options?: { popupTitle?: string }) => void };
    };
  }
}

const POSTCODE_SCRIPT_ID = "daum-postcode-script";
const POSTCODE_SCRIPT_URL = "https://t1.kakaocdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";
let postcodeLoader: Promise<void> | null = null;

function loadPostcodeSearch() {
  if (window.daum?.Postcode) return Promise.resolve();
  if (postcodeLoader) return postcodeLoader;
  postcodeLoader = new Promise<void>((resolve, reject) => {
    const existing = document.getElementById(POSTCODE_SCRIPT_ID) as HTMLScriptElement | null;
    if (existing) existing.remove();
    const script = document.createElement("script");
    script.id = POSTCODE_SCRIPT_ID;
    script.src = POSTCODE_SCRIPT_URL;
    script.async = true;
    script.onload = () => window.daum?.Postcode ? resolve() : reject(new Error("주소검색 서비스를 불러오지 못했습니다."));
    script.onerror = () => reject(new Error("주소검색 서비스를 불러오지 못했습니다."));
    document.head.appendChild(script);
  }).catch((error) => {
    postcodeLoader = null;
    throw error;
  });
  return postcodeLoader;
}

export async function openPostcodeSearch(onComplete: (result: PostcodeResult) => void) {
  await loadPostcodeSearch();
  const Postcode = window.daum?.Postcode;
  if (!Postcode) throw new Error("주소검색 서비스를 사용할 수 없습니다.");
  new Postcode({ oncomplete: onComplete }).open({ popupTitle: "주소검색" });
}
